import { Component, OnInit } from '@angular/core';
import { AppService } from './app.service';
import { LabEmitterService } from './common-services/lab-emitter.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  newUI: boolean = false;

  constructor(private appService: AppService, private _labEmitterService: LabEmitterService) { }

  ngOnInit(): void {
    this.appService.refreshFeatures();
    this.newUI = localStorage.getItem("newUI") == "true";
    this._labEmitterService.change.subscribe( _ => {
      this.newUI = localStorage.getItem("newUI") == "true";
    });

  }

}
